
    // Delegated hover handlers on .image-cont to trigger CSS-based image swap
    // Works for initial load AND Ajaxinate infinite scroll appended products
    (function () {
      document.addEventListener('mouseenter', function(e) {
        const imageCont = e.target.closest('.image-cont--with-secondary-image');
        if (!imageCont) return;
        
        // Find primary and secondary images
        const primaryImg = imageCont.querySelector('.product-block__image--primary');
        const secondaryImg = imageCont.querySelector('.product-block__image--show-on-hover');
        
        if (primaryImg && secondaryImg) {
          // Hide primary
          primaryImg.classList.remove('product-block__image--active');
          
          // Show secondary - remove display:none and make visible
          secondaryImg.classList.remove('product-block__image--inactivated');
          secondaryImg.classList.add('product-block__image--active');
          
          // Force lazySizes to load the background if not already loaded
          if (window.lazySizes && window.lazySizes.loader) {
            var bgEl = secondaryImg.querySelector('[data-lazy-bgset-src]');
            if (bgEl) {
              window.lazySizes.loader.unveil(bgEl);
            }
          }
        }
      }, true);

      document.addEventListener('mouseleave', function(e) {
        const imageCont = e.target.closest('.image-cont--with-secondary-image');
        if (!imageCont) return;
        
        // Find primary and secondary images
        const primaryImg = imageCont.querySelector('.product-block__image--primary');
        const secondaryImg = imageCont.querySelector('.product-block__image--show-on-hover');
        
        if (primaryImg && secondaryImg) {
          // Show primary
          primaryImg.classList.add('product-block__image--active');
          
          // Hide secondary
          secondaryImg.classList.remove('product-block__image--active');
          secondaryImg.classList.add('product-block__image--inactivated');
        }
      }, true);
    })();

      // Initialize product block images on first load and after Ajaxinate appends content
      document.addEventListener('DOMContentLoaded', function () {
        try {
          if (window.theme && theme.ProductBlockManager) {
            var loop = document.querySelector('#Huratips-Loop');
            theme.ProductBlockManager.loadImages(loop || document.body);
          }
        } catch (err) {
          console.error('ProductBlockManager init error:', err);
        }
      });

      // Use MutationObserver to detect when Ajaxinate appends new products
      // and reinitialize lazy backgrounds and image hover behavior
      (function() {
        var loop = document.querySelector('#Huratips-Loop');
        if (!loop) return;

        var reinitImages = function() {
          if (window.theme && theme.ProductBlockManager) {
            try {
              // Reinitialize all images (converts data-lazy-bgset-src to data-bgset)
              theme.ProductBlockManager.loadImages(loop);
              
              // Force lazySizes to process the new elements
              if (window.lazySizes && window.lazySizes.loader) {
                setTimeout(function() {
                  loop.querySelectorAll('[data-lazy-bgset-src]').forEach(function(el) {
                    window.lazySizes.loader.unveil(el);
                  });
                }, 50);
              }
            } catch (err) {
              console.error('Image reinitialization error:', err);
            }
          }
        };

        // Observe for new product-block additions
        var observer = new MutationObserver(function(mutations) {
          var hasNewProducts = false;
          mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length > 0) {
              mutation.addedNodes.forEach(function(node) {
                if (node.classList && node.classList.contains('product-block')) {
                  hasNewProducts = true;
                } else if (node.querySelectorAll && node.querySelectorAll('.product-block').length > 0) {
                  hasNewProducts = true;
                }
              });
            }
          });
          
          if (hasNewProducts) {
            reinitImages();
          }
        });

        // Watch for child additions/removals
        observer.observe(loop, { childList: true, subtree: true });
      })();

      // Also listen for common Ajaxinate events (ajaxinate:added, ajaxinate:updated)
      document.addEventListener('ajaxinate:added', function(e) {
        try {
          if (window.theme && theme.ProductBlockManager) {
            var loop = document.querySelector('#Huratips-Loop');
            theme.ProductBlockManager.loadImages(loop);
          }
        } catch (err) {
          console.error('ajaxinate:added error:', err);
        }
      });

      document.addEventListener('ajaxinate:updated', function(e) {
        try {
          if (window.theme && theme.ProductBlockManager) {
            var loop = document.querySelector('#Huratips-Loop');
            theme.ProductBlockManager.loadImages(loop);
          }
        } catch (err) {
          console.error('ajaxinate:updated error:', err);
        }
      });